function initDisableOnSubmitButtons() {
  const btns = document.querySelectorAll<HTMLButtonElement>(
    'button.disable-on-submit',
  )
  for (const btn of btns) {
    btn.onclick = () => {
      // Disable the button to prevent multiple submissions
      btn.disabled = true
      // Submit the form
      btn.form?.submit()
    }
  }
}

export { initDisableOnSubmitButtons }
